import styled, { keyframes } from 'styled-components';

const fadeInKeyframes = keyframes`
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
`;

export const FadeIn = styled.div`
	display: inherit;
	animation: ${fadeInKeyframes} 0.4s ease-out;
`;
